import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import QuestionType from '@ax2/common/model/QuestionType';
import ReportType from 'model/reports/ReportType';

export interface QuestionReportTypes {
  defaultReport: ReportType;
  allowedReports: ReportType[];
}

export const getReportTypes = (
  question: QuestionSchema
): QuestionReportTypes => {
  switch (question.questionType) {
    case QuestionType.OpenEndedNumeric:
    case QuestionType.OpenEndedText:
    case QuestionType.TextboxListText:
      return {
        defaultReport: ReportType.ResponseTable,
        allowedReports: [ReportType.ResponseTable],
      };
    case QuestionType.RatingList:
      return {
        defaultReport: ReportType.StackedBarChart,
        allowedReports: [
          ReportType.StackedBarChart,
          ReportType.HorizontalStackedBarChart,
        ],
      };
    case QuestionType.CheckboxGrid:
    case QuestionType.RadioButtonGrid:
    case QuestionType.RadioButtonGridRow:
    case QuestionType.TextboxGridNumeric:
      return {
        defaultReport: ReportType.GridResponseTable,
        allowedReports: [ReportType.GridResponseTable],
      };
    case QuestionType.RadioButtonList:
    case QuestionType.DropdownMenu:
      return {
        defaultReport: ReportType.PieChart,
        allowedReports: [ReportType.PieChart, ReportType.DoughnutChart],
      };
    case QuestionType.CheckboxList:
      return {
        defaultReport: ReportType.BarChart,
        allowedReports: [ReportType.BarChart, ReportType.HorizontalBarChart],
      };
    case QuestionType.ContinuousSumList:
      return {
        defaultReport: ReportType.StatisticsTable,
        allowedReports: [ReportType.StatisticsTable],
      };
    case QuestionType.RankingList:
      return {
        defaultReport: ReportType.RanksTableReport,
        allowedReports: [ReportType.RanksTableReport],
      };
    case QuestionType.TextboxListNumeric:
      return {
        defaultReport: ReportType.StatisticsTable,
        allowedReports: [ReportType.StatisticsTable, ReportType.ResponseTable],
      };

    default:
      throw Error(
        `Unknown Question Type (${question.questionType}) was used in report types builder.`
      );
  }
};
